import axios from 'axios'
import {API_URL} from '../constants';

const USERS_API_URL = `${API_URL}/users`;

class UserDataService {

    retrieveUsers() {
        const token = sessionStorage.getItem('token');
        return axios.get(`${USERS_API_URL}/findAll`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    retrieveUsersBy(viewall) {
        const token = sessionStorage.getItem('token');
        return axios.get(`${USERS_API_URL}/findAll?viewall=${viewall}`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    retrieveUsersByName(name) {
        const token = sessionStorage.getItem('token');
        let info = {
            username: name
        };
        return axios.post(`${USERS_API_URL}/findByName`, info,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    retrieveUsersByNameAndViewAll(name, viewAll) {
        const token = sessionStorage.getItem('token');
        let info = {
            username: name,
            viewAll: viewAll
        };
        return axios.post(`${USERS_API_URL}/findByName`, info,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    retrieveById(id) {
        const token = sessionStorage.getItem('token');
        return axios.get(`${USERS_API_URL}/findById/${id}`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    retrieveWorkers() {
        const token = sessionStorage.getItem('token');
        return axios.get(`${USERS_API_URL}/findWorkers`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    retrieveErrorReporters() {
        const token = sessionStorage.getItem('token');
        return axios.get(`${USERS_API_URL}/errorReporters`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    retrieveWorkersWithCapacity() {
        const token = sessionStorage.getItem('token');
        return axios.get(`${USERS_API_URL}/findWorkersWithCapacity`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    saveMasterCapacity(info){
        const token = sessionStorage.getItem('token');
        return axios.post(`${USERS_API_URL}/saveMasterCapacity`,info,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    retrieveDesigners() {
        const token = sessionStorage.getItem('token');
        return axios.get(`${USERS_API_URL}/findDesigners`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    } 

    // retrieveWorkers() {
    //     const token = sessionStorage.getItem('token');
    //     return axios.get(`${USERS_API_URL}/findWorkers`,
    //         { headers: { 'Authorization': `Bearer ${token}` } }
    //     ).then(response => {
    //         return response.data;
    //     }).catch(error => {
    //         return error;
    //     });
    // }       

    save(user) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${USERS_API_URL}/save`, user,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    update(user) {
        const token = sessionStorage.getItem('token');
        return axios.put(`${USERS_API_URL}/update`, user,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    delete(id) {
        const token = sessionStorage.getItem('token');
        return axios.delete(`${USERS_API_URL}/${id}`, 
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    retrieveNextFilename(dataType) {
        const token = sessionStorage.getItem('token');
        return axios.get(`${USERS_API_URL}/nextFilename/${dataType}`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }    
}

export default new UserDataService()